<template>
    <card
        class="o-card-place"
        modifier="place"
        :bg="bg"
    >
        <template #inner>
            <header class="o-card-place__inner">
                <asset
                    class="o-card-place__logo"
                    :image="logo"
                    size="w90&h90"
                    :cover="true"
                />

                <h3
                    v-if="title"
                    class="o-card-place__title"
                >
                    {{ title }}
                </h3>

                <div
                    v-if="website.url || facebook.url"
                    class="o-card-place__links"
                >
                    <a
                        v-if="website.url"
                        :href="website.url"
                        :title="title"
                        class="o-card-place__website"
                        target="_blank"
                        rel="noopener"
                    >
                        {{ websiteName }}
                    </a>
                    <a
                        v-if="facebook.url"
                        :href="facebook.url"
                        :title="title"
                        class="o-card-place__facebook"
                        target="_blank"
                        rel="noopener"
                    >
                        <icon icon="facebook" />
                    </a>
                </div>
            </header>
            <graph
                v-if="graph.title"
                :svg="graph.svg"
                :title="graph.title"
                :desc="graph.desc"
            />
        </template>
    </card>
</template>

<script>

import Icon from 'objects/Icon';
import Asset from 'objects/Asset';
import Card from 'components/Card';
import Graph from 'components/Graph';

export default {
    name: 'CardPlace',
    components: {
        Icon,
        Asset,
        Card,
        Graph,
    },
    props: {
        bg: {
            type: String,
            default: null,
        },
        logo: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        graph: {
            type: Object,
            default: () => ({
                svg: null,
                title: null,
                desc: Array,
            })
        },
        website: {
            type: Object,
        },
        facebook: {
            type: Object,
        },
    },
    computed: {
        websiteName() {
            const url = this.website.url

            return url ? url.replace(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?/i, "").split('/')[0] : false
        },
    }
};
</script>

<style lang="scss">

.o-card-place {

    .c-graph {
        max-width: none;
        padding: 0;
    }

    .c-graph__icon {
        max-width: 12em;
        max-height: 12em
    }

    .c-graph__content {
        width: calc(100% - var(--corner-size-x));
    }
}

.o-card-place__inner {
    margin-bottom: 1em;
    padding-bottom: 1em;

    @media #{md("xs")} {
        margin-bottom: 2.6em;
        padding-bottom: 2.6em;
    }
}

.o-card-place__logo {
    display: block;
    width: 5.6em;
    height: 5.6em;
    border-radius: 50%;
}

.o-card-place__title {
    font-family: ff("heading");
    font-size: 1.875em;
    font-weight: 400;
    margin-top: .5em;
}

.o-card-place__links {
    display: flex;
    align-items: center;
    margin-top: 2em;
}

.o-card-place__website {
    display: inline-block;

    &:before {
        @include pseudo-el($height: .1em, $bg: currentColor);
        position: absolute;
        bottom: -.25em;
        left: 0;
    }
}

.o-card-place__facebook {
    display: inline-block;
    margin-left: 3em;
}

</style>
